import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const insights = [
    {
      icon: 'Target',
      title: 'Pinpoint What Recruiters Actually Want',
      description:
        "We analyze the job and your resume to show you the exact skills you're missing. It's the same honest feedback you'd get from a (very busy) senior mentor."
    },
    {
      icon: 'Map',
      title: 'A Curated Learning Plan',
      description:
        "We don't just list 50 random courses. You get a focused, practical roadmap of videos and courses to close your skill gap, fast — plus essential AI skills to acquire in the current job market."
    },
    {
      icon: 'BarChart',
      title: 'Don’t Just See the Gaps—Bridge Them',
      description:
        'We use your unique data to generate hyper-contextualized interview prep and specific resume tips that turn your weaknesses into talking points. Walk into your interview knowing exactly what they’ll ask and how to answer.'
    }
  ];

  return (
    <div className="space-y-8">

      {/* Expert Insights */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-4 flex items-center space-x-2">
          <Icon name="Sparkles" size={20} className="text-primary" />
          <span>Expert Insights, Powered by AI</span>
        </h3>

        <div className="space-y-5">
          {insights.map((item, idx) => (
            <div key={idx} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={item.icon} size={16} className="text-primary" />
              </div>
              <div>
                <div className="text-sm font-semibold text-card-foreground">
                  {item.title}
                </div>
                <div className="text-xs text-muted-foreground mt-1 leading-relaxed">
                  {item.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Ecosystem */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-4 flex items-center space-x-2">
          <Icon name="Globe" size={20} className="text-primary" />
          <span>Explore Our Ecosystem</span>
        </h3>

        <div className="space-y-4">
          {/* AIBrahmi */}
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="BookOpen" size={16} className="text-primary" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-semibold text-card-foreground">AIBrahmi</div>
              <div className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Curates the most relevant AI developments for practical understanding across technical and non-technical audiences. Apply AI in everyday life and enterprise.
              </div>
              <button
                onClick={() => {
                  const ok = window.confirm('You are about to leave JobAspirant and go to AIBrahmi. Continue?');
                  if (ok) window.open('https://aibrahmi.com/', '_blank', 'noopener,noreferrer');
                }}
                className="mt-2 text-xs text-primary hover:underline"
              >
                Visit AIBrahmi →
              </button>
            </div>
          </div>

          {/* CareerSupportIndia */}
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Users" size={16} className="text-primary" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-semibold text-card-foreground">CareerSupportIndia (Reddit)</div>
              <div className="text-xs text-muted-foreground mt-1 leading-relaxed">
                A community for career growth, skills, jobs, interview preparation, and peer support.
              </div>
              <button
                onClick={() => {
                  const ok = window.confirm('You are about to leave JobAspirant and go to r/CareerSupportIndia. Continue?');
                  if (ok) window.open('https://www.reddit.com/r/CareerSupportIndia/', '_blank', 'noopener,noreferrer');
                }}
                className="mt-2 text-xs text-primary hover:underline"
              >
                Join the Subreddit →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;